<template>
    <div class="brand_media">
        <!-- 1. 品牌媒体关注分析 -->
        <titleTem :passTitleData="passTitleData"></titleTem>
        <ul class="date_select clearfix">
            <li
                    v-for="(item,index) of dateData"
                    :class="{active:item.type == activeName}"
                    :key="index"
                    @click="getClickId(item)"
            >{{item.date}}
            </li>
        </ul>

        <div class="echarts_container">
            <Eline :echartsData="echartsData" :isNodata="isNodata"></Eline>
        </div>
        <!-- 点击自定义 弹框 -->
        <el-dialog title="StartDate" :visible.sync="dialogDateSelect" :before-close="handleClose">
            <div v-if="!isMyDate">
                <el-date-picker
                        v-model="value"
                        type="daterange"
                        size="large"
                        align="center"
                        unlink-panels
                        range-separator="-"
                        start-placeholder="StartDate"
                        end-placeholder="EndDate"
                        :picker-options="pickerOptions"
                ></el-date-picker>

                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="sure">confirm</el-button>
                </div>
            </div>
            <DatePicker
                    v-else
                    :startTime="startDate"
                    :endTime="endDate"
                    @startConfirm="startConfirm"
                    @endConfirm="endConfirm"
                    @startCancel="startCancel"
                    @endCancel="endCancel"
                    @startClear="startClear"
                    @endClear="endClear"
            ></DatePicker>
        </el-dialog>
    </div>
</template>

<script>
import titleTem from './Title'
import Eline from '../echarts/BrandMediaLine'
import axios from 'axios'
import {brandVolume} from '@/common/js/http/version3Api.js'
import DatePicker from '../mobile/DatePickerLocal'

const power = JSON.parse(localStorage.getItem('power'))
export default {
  name: 'BrandMedia',
  components: {
    titleTem,
    Eline,
    DatePicker
  },
  data () {
    return {
      isMyDate: false,
      isNodata: false,
      dialogDateSelect: false,
      pickerOptions: {
        shortcuts: [
          {
            text: 'Last 3 months',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Last year',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      value: '',
      //品牌id
      companyID: this.$route.query.id || power[0].id,
      activeName: 'ALL',
      dateData: [
        {
          id: 24,
          date: 'All',
          type: 'ALL'
        },
        {
          id: 7,
          date: '7 days',
          type: 'WEEK'
        },
        {
          id: 30,
          date: '30 days',
          type: 'MONTH'
        },
        {
          id: 12,
          date: 'Half a year',
          type: 'YEAR'
        },
        {
          id: 25,
          date: 'Customize',
          type: 'CUSTOM'
        }
      ],
      startDate: '',
      endDate: '',
      passTitleData: {
        titleName: 'Trend Analysis of Brand Volume',
        commentTxt:
          'It refers to the amount of brand postings by foreign media monitored by the system within a certain time frame (since data collection by default). Double-click the chart to drill down the data.'
      },

      // 折线图数据
      // echartsData: [
      //   ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],//xAxis
      //   [
      //     {
      //       name: "Voice volume index",//yAxis
      //       data: [820, 932, 901, 934, 1290, 1330, 1320]//series

      //     }
      //   ]
      // ],
      echartsData: []
    }
  },
  mounted () {
    //屏幕宽度
    if (document.documentElement.clientWidth < 768) this.isMyDate = true
    else this.isMyDate = false
    this.getBrandvolume()
  },
  methods: {
    //切换时间
    getClickId (val) {
      this.activeName = val.type
      if (this.activeName === 'CUSTOM') {
        this.dialogDateSelect = true
      } else {
        this.getBrandvolume()
      }
    },
    //点击关闭
    handleClose (val) {
      this.dialogDateSelect = false
      //this.getBrandvolume();
    },
    //点击确定
    sure () {
      this.dialogDateSelect = false
      let start = new Date(this.value[0])
      let startTime =
        start.getFullYear() +
        '-' +
        (start.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        start
          .getDate()
          .toString()
          .padStart(2, '0')
      let end = new Date(this.value[1])
      let endTime =
        end.getFullYear() +
        '-' +
        (end.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        end
          .getDate()
          .toString()
          .padStart(2, '0')
      this.startDate = startTime
      this.endDate = endTime

      this.value = ''
      this.getBrandvolume()
    },
    getBrandvolume () {
      if (this.startDate == null || this.startDate == 'Invalid date') {
        this.startDate = ''
      }
      if (this.endDate == null || this.endDate == 'Invalid date') {
        this.endDate = ''
      }
      let data = {
        companyId: this.companyID,
        dateType: this.activeName,
        startTime: this.startDate,
        endTime: this.endDate,
        brandToken: localStorage.getItem('brand-token')
      }
      brandVolume(data).then(res => {
        let firstArray = [],
          secondArray = []
        let one = firstArray.push({
          name: res.result.yAxis.name,
          data: res.result.series[0].data
        })
        let two = secondArray.push(res.result.xAxis.data, firstArray)
        this.$set(this.echartsData, 'lineData', secondArray)
        this.echartsData = this.echartsData.lineData
        if (this.echartsData[0].length === 0) {
          this.isNodata = true
        } else {
          this.isNodata = false
        }
      })
    },
    //移动端日期选择
    startConfirm (startTime) {
      this.startDate = this.$moment(new Date(startTime)).format('YYYY-MM-DD')
      this.getBrandvolume()
    },
    endConfirm (endTime) {
      this.endDate = this.$moment(new Date(endTime)).format('YYYY-MM-DD')
      this.getBrandvolume()
      this.dialogDateSelect = false
    },
    startCancel () {
      this.startDate = ''
      this.getBrandvolume()
    },
    endCancel () {
      this.endDate = ''
      this.getBrandvolume()
    },
    startClear () {
      this.startDate = ''
      this.getBrandvolume()
    },
    endClear () {
      this.endDate = ''
      this.getBrandvolume()
    }
  },
  watch: {
    value () {
      if (this.value == null) {
        return
      }
    }
  }
}
</script>

<style>
    .title {
        padding-top: 10px;
    }

    .date_select {
        padding: 20px 0 25px;
    }

    .date_select li {
        cursor: pointer;
        float: left;
        width: 108px;
        height: 32px;
        font-size: 14px;
        color: #4e5671;
        line-height: 32px;
        text-align: center;
        background: #f7f8fa;
        font-family: RCR;
    }

    .date_select .active {
        color: #fff !important;
        background: #0078ff !important;
    }

    .el-dialog__body .el-date-editor .el-range-separator {
        padding: 0 24px !important;
    }

    .el-date-editor .el-range-input {
        padding-left: 14px;
    }

    .dialog-footer {
        text-align: right;
        padding-top: 10px;
    }

    @media screen and (max-width: 768px) {
        .el-dialog {
            width: 80% !important;
        }
    }
</style>
